import { useAuth } from './useAuth';
import * as PermsConfig from '../../firebase/permissions';

/**
 * usePermissions - Hook de validación de acciones contra la ACL y exportación del perfil
 */
export const usePermissions = () => {
    const authData = useAuth();
    const { user, role, isFullUser, loadingAuth } = authData;

    const can = (action) => {
        if (loadingAuth || !user) return false;

        if (!isFullUser && (action.startsWith('CREAR_') || action.startsWith('EDITAR_') || action.startsWith('ELIMINAR_'))) {
            return false;
        }

        const checkFn = PermsConfig.checkPermission || PermsConfig.default?.checkPermission;

        if (typeof checkFn !== 'function') {
            console.error("[usePermissions] Error crítico: No se pudo resolver la función 'checkPermission'.");
            return false;
        }

        return checkFn(role, action);
    };

    return {
        ...authData, // Expone userName, userInitials, userEmail, user, profile, etc.
        can,
        loadingAuth,
        isFullUser
    };
};